// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const POST_DELETED_BECAUSE_reason = "D\u00f4vod: %(reason)s";
export const POST_DELETED_BY_ADMIN = "Pr\u00edspevok zmazan\u00fd adminom";
export const POST_DELETED_BY_AUTHOR = "Pr\u00edspevok zmazan\u00fd autorom";
export const POST_REMOVE_COMPLAINTS = "Zru\u0161 nahl\u00e1senie pr\u00edspevku";
export const TOPIC_MODERATOR = "Moder\u00e1tor";
